import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { Dayjs } from 'dayjs';
import ConfirmView from './confirm';
import FormView from './form';

type ExtendPauseDialogViewProps = CustomDialogProps & {
  policy: PolicyModel;
};

const ExtendPauseDialogView = (props: ExtendPauseDialogViewProps) => {
  const { policy, close } = props;
  const [step, setStep] = useState(1);
  const [endDate, setEndDate] = useState<Dayjs>(null);

  /**
   * methods
   */
  // form info click next
  const formContinueAction = ({ time }) => {
    setEndDate(time);
    setStep(2);
  };

  return (
    <>
      {step === 1 && <FormView close={close} policy={policy} confirm={formContinueAction} endDate={endDate} />}
      {step === 2 && <ConfirmView policy={policy} close={close} endDate={endDate} back={() => setStep(1)} />}
    </>
  );
};

export default ExtendPauseDialogView;
